var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.2214V2C0 0.895431 0.89543 0 2 0H22C23.1046 0 24 0.895431 24 2V23.0347C24 24.6764 22.1314 25.6189 20.8112 24.6431L13.6406 19.343C12.9574 18.8381 12.0297 18.8198 11.3272 19.2975L3.12462 24.8753C1.79681 25.7782 0 24.8271 0 23.2214Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.60190cfaa4e6c14e14b87554ead05c9c.svg";
export { ForwardRef as ReactComponent };